import { render, staticRenderFns } from "./currencyDetails.vue?vue&type=template&id=177ae82a"
import script from "./currencyDetails.vue?vue&type=script&lang=js"
export * from "./currencyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports